import React from "react";
import { ValidationError } from "../../../common/lib/validation";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input as BootstrapInput,
  FormFeedback,
  Button
} from "reactstrap";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ],

    ["link"],
    ["clean"]
  ]
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link"
];

class Wysiwyg extends React.Component {
  constructor(props) {
    super(props);
    if (typeof window !== "undefined") {
      this.ReactQuill = require("react-quill");
    }
  }

  onChange = (value, a, b) => {
    const { onChange } = this.props;
    if (b === "user") {
      onChange({ target: { value } });
    }
  };

  render() {
    const {
      field,
      title,
      className,
      placeholder,
      loading,
      preview,
      clearError,
      error,
      value,
      onChange
    } = this.props;

    let cs = className;
    const ReactQuill = this.ReactQuill;

    return (
      <FormGroup
        className={"flex-items-xs-middle"}
        color={ValidationError.isInvalid(error, field) ? "danger" : ""}
      >
        <Label for={field}>{title}</Label>
        {typeof window !== "undefined" &&
        ReactQuill && (
          <ReactQuill
            theme="snow"
            onChange={this.onChange}
            formats={formats}
            modules={modules}
            value={value}
          />
        )}
        {ValidationError.isInvalid(error, field) && (
          <FormFeedback>{ValidationError.getError(error, field)}</FormFeedback>
        )}
      </FormGroup>
    );
  }
}

export default Wysiwyg;



// WEBPACK FOOTER //
// ./src/browser/components/Form/Wysiwyg.js